import React from 'react';


export default class Message extends React.Component {
  
  constructor(props) {
    super(props);
    this.style = {};
    this.isLink() ? this.style = {cursor: 'pointer'} : this.style = {};
  }
  
  shouldComponentUpdate(nextProps) {
      return false;
  } 

  isLink() { 
    return this.props.message.msg.match(/(http(s)?:\/\/[^\s]+)/g);
  }
 
  isLinkThenOpen = (e) => {
    if(this.isLink()){
      e.preventDefault();
      window.open(this.props.message.msg, '_blank');
    }
  }
 
  text() {
    let icon = '';


    return (
        <div className="message-content">
            <p className="message-text" style={ this.style } onClick={ this.isLinkThenOpen }>{  this.props.message.msg }</p>
        </div>
    )
  }

  displayContentMessage(){
    if(this.props.message.document){
      return this.media()
    }else {
      return this.text()
    }
  }

  media(){

    let type = this.getFileType(this.props.message.document.type)
  
    if(type == 'image'){
      return <div className="message-content message-media">
              <img src={'//' + window.sdk.getApiUrl() + this.props.message.document.thumb} onClick={() => {window.sdk.lightboxMedia(this.props.message.document)}} />
          </div>
    }
  else if(type == 'video'){
    return <div className="message-content message-media">
             <i className={'icon-file-video'} onClick={() => {window.sdk.lightboxMedia(this.props.message.document)}} />
        </div>
  } else {
      return <a className="message-content message-media" target="_blank" href={'//' + window.sdk.getApiUrl() + this.props.message.document.path} download={this.props.message.document}>        
        <i className={'icon-file' + (type ? '-'+type : '')} />
        </a>
    }
  }
  getFileType(mimetype) {
    if (mimetype.startsWith("image")) {
        return "image";
    } else if (mimetype.startsWith("video")) {
        return "video";
    } else if (mimetype.startsWith("audio")) {
        return "audio";
    } else if (mimetype === "application/pdf") {
        return "pdf";
    } else {
        return "";
    }
}
  render() {
    let className = 'message';
    if(this.props.message.session.token == window.sdk.session().getToken())
        className += ' my-message';

    return (
      
      <li id={'message-' +   this.props.message.id} className={className}>  
        { this.displayContentMessage() }
      </li>
    );
  }

}
